$(function(){
  var instances = [];

  function toNum(v, fallback) {
    var n = Number(v);
    return isNaN(n) ? fallback : n;
  }
  function toBool(v, fallback) {
    if (v === undefined || v === null || v === '') return fallback;
    var s = String(v).toLowerCase();
    if (s === 'true') return true;
    if (s === 'false') return false;
    return fallback;
  }

  $('.js-swiper').each(function(){
    var $el = $(this);

    // jQueryの .data() は data-sp-view -> spView のように camelCase で取得できます
    var spView  = toNum($el.data('spView'),  1);
    var spGroup = toNum($el.data('spGroup'), 1);
    var pcView  = toNum($el.data('pcView'),  3);
    var pcGroup = toNum($el.data('pcGroup'), 1);
    var space   = toNum($el.data('space'),   16);
    var speed   = toNum($el.data('speed'),   500);
    var loopAttr = toBool($el.data('loop'),  false);
    var spRows   = toNum($el.data('spRows'), 1); // 例: 2にすると2行
    var pcRows   = toNum($el.data('pcRows'), 1); // 例: 2にすると2行

    var loop = (spRows === 1 && pcRows === 1) ? loopAttr : false;
    // var loop = loopAttr;

    // ★ 外部ナビのセレクタ（任意）
    var selPrev = $el.data('navprev');
    var selNext = $el.data('navnext');

    var prevEl = selPrev ? document.querySelector(selPrev) : $el.find('.swiper-button-prev')[0];
    var nextEl = selNext ? document.querySelector(selNext) : $el.find('.swiper-button-next')[0];
    var pagEl  = $el.find('.swiper-pagination')[0]; // 任意

    var swiper = new Swiper($el[0], {
      speed: speed,
      spaceBetween: space,
      loop: loop,
      watchOverflow: true,
      centeredSlides: false,

      // 各コンテナ内のUIをスコープ（衝突防止）
      navigation: { 
        prevEl: prevEl, 
        nextEl: nextEl
      },
      pagination: {
        el: $el.find('.swiper-pagination')[0],
        clickable: true
      },

      // PC
      slidesPerView: pcView,
      slidesPerGroup: pcGroup,
      slidesPerColumn: pcRows,

      // 端数が出る & loop時の体裁調整
      loopFillGroupWithBlank: loop,

      // SP
      breakpoints: {
        650: {
          slidesPerView: spView,
          slidesPerGroup: spGroup,
          slidesPerColumn: spRows,
        }
      },

      // タブ/アコーディオン内での初期化に強い設定
      observer: true,
      observeParents: true
    });

    instances.push(swiper);
  });

  // 例：タブ表示時に再計算したい場合
  // $(document).on('shown.myTab', function(){ instances.forEach(function(s){ s.update(); }); });
});

// アンカーリンク高さ制御
$(function () {
  $('a[href^="#"]:not([href="#"])').click(function () {

    var headerHight = 125; //ヘッダーの高さ

    if(window.matchMedia("(max-width: 768px)").matches){
      headerHight = 0;
    }

    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight;
    $("html, body").animate({
    scrollTop: position
    }, 500, "swing");
    return false;
  });
});


//MVのスライドイン
window.addEventListener("load", () => {
  const targets = document.querySelectorAll(
    ".p-midyeargift-mv__copy-image, .p-midyeargift-mv__copy-image-02"
  );
  if (!targets.length) return;

  setTimeout(() => {
    targets.forEach(target => {
      target.classList.add("is-active");
    });
  }, 300);
});

//下からふわっと

document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-fade");
  if (!targets.length) return;

  const options = {
    root: null,
    rootMargin: "-30% 0px", // 発火位置の調整
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-active");
        observer.unobserve(entry.target);
      }
    });
  }, options);

  targets.forEach(target => {
    observer.observe(target);
  });
});
